import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { GlobalContext } from "../../context/globalContext";
import { BusinessContext } from "../../context/businessContext";
import { httpIAPI_FAC006 } from "./api/request";
import { infoManual, infoManualTwo, stepperData } from "./parts";
import "./_style.scss";
import TkContractorAndNumberLine from "../../components/molecules/TkContractorAndNumberLine";
import { Box, Typography } from "@mui/material";
import TkStrpper from "../../components/atoms/TkStepper";
import TkStaffChangesTable from "./components";
import { TkRStaffChangeProps } from "../../type/componentsType/ITkRStaffChangesTableProps";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import TkHelpIcon from "../../components/atoms/TkHelpIcon";
import TkMessageDialog from "../../components/molecules/TkMessageDialog";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import { TkGetCode } from "../../utils/TkGetCode";
import { SexFlug } from "../../assets/data/Constants";

/**
 * SCRC050123 職員の異動状況登録
 * このコンポーネントは、TkInfoManual、TkFakeTable、TkMessageDialogをレンダリングします。
 * @return SCRC050123 職員の異動状況登録
 */
const SCRC050123 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const locationState = location.state;
  const { state, setState } = useContext(GlobalContext);
  const { state: businessState } = useContext(BusinessContext);
  const userType = state.authInfo?.userType;
  const [staffList, setStaffList] = useState<TkRStaffChangeProps[]>([]);
  const [disabled, setDisabled] = useState(false);
  const [openInit, setOpenInit] = useState(true);
  const allDisabled = locationState?.staffTransferStatus === "登録完了";

  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 初期処理
  const handleInit = async () => {
    try {
      const res = await httpIAPI_FAC006({
        contractorNo:
          userType === authorityUserType.userTypeNumber.KIKO
            ? businessState.common?.contractorNo
            : state.authInfo?.contractorNo,
        applyId: businessState.job_18?.applyId,
        facilityNo: locationState?.facilityNo,
        transferDate: locationState?.transferDate,
      });

      // 初期表示
      if (res.resultCd === "I0000") {
        const infoList: TkRStaffChangeProps[] = [];
        res.staffSelectionList?.forEach((item: any, index: number) => {
          const data: TkRStaffChangeProps = {
            index: index,
            reconfiguration: item.transferReason === "99" ? "1" : "0", //配置換え
            transferee: item.transferReason === "12" ? "1" : "0", //譲渡先法人へ異動
            resignation: item.transferReason === "2" ? "1" : "0", //退職（廃止日が退職日となります。）
            staffNo: item.staffNo, // 職員番号
            staffNameKanji: item.staffNameKanji, // 職員氏名
            sex: TkGetCode(SexFlug, item.sex), // 法人職員性別
            birthday: item.birthday, // 法人職員生年月日
            jobName: item.jobName, //職種名
            updateDateTime: item.updateDateTime, //更新日時
          };
          infoList.push(data);
        });
        setStaffList(infoList);
        setDisabled(res.businessTransferSelectabilityFlg === "0");
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  return (
    <Box
      data-testid="SCRC050123PageForTest"
      display={openInit ? "none" : "-moz-initial"}
    >
      <TkStrpper steps={stepperData} activeStep={1} />

      <Box className="SCRC050123InfoManual">
        <TkInfoManual rule={"\\n"}>{infoManual}</TkInfoManual>
        <TkHelpIcon
          helpMessage={
            <>
              退職が選択されている職員は廃止日をもって、退職となります。
              <br />
              残務整理等に従事していたとしても被共済職員として加入し続けることはできません。
            </>
          }
        />
      </Box>
      <Box className="SCRC050123InfoManualTwo">
        <TkInfoManual rule={"\\n"}>{infoManualTwo}</TkInfoManual>
      </Box>
      {userType === authorityUserType.userTypeNumber.KIKO && (
        <TkContractorAndNumberLine
          name="契約者（法人）名"
          no={
            businessState.common?.contractorNo +
            ":" +
            businessState.common?.contractorName
          }
        />
      )}
      <Box>
        <Typography>
          {"施設番号：" +
            locationState?.facilityNo! +
            "　施設名：" +
            locationState?.facilityName!}
        </Typography>
      </Box>

      {!!staffList?.length ? (
        <TkStaffChangesTable key={1} staffs={staffList} disabled={disabled} allDisabled={allDisabled}/>
      ) : (
        <TkStaffChangesTable key={2} staffs={[]} disabled={disabled} allDisabled={allDisabled}/>
      )}

      <TkMessageDialog
        open={openInit}
        onOky={() => {
          handleInit();
          setOpenInit(false);
        }}
        title="事前確認"
        contextText="　廃止・休止・経営移管日より前の日付で配置換え・退職している職員については、先に配置換えの処理・退職の処理を行ってください。"
        okText="はい"
        cancelText=""
      />
    </Box>
  );
};

export default SCRC050123;
